function fn_comp_reviews() {
    var $fn = $(".comp_reviews");

    if($fn.length) {
        $fn.find(".elm_review").each(function (index) {
            var $this = $(this);
            var $points = [];
            if($this.hasClass("mod--color-a")){
                $points = [[98.5, 2.6], [0.0, 0.0], [1.7, 100.0], [100.0, 98.3]];
            }
            if($this.hasClass("mod--color-b")){
                $points = [[1.5, 2.6], [100.0, 0.0], [98.3, 100.0], [0.0, 98.3]];
            }
            if($this.hasClass("mod--color-c")){
                $points = [[98.5, 2.6], [0.0, 0.0], [1.7, 100.0], [100.0, 98.3]];
            }
            if($this.hasClass("mod--color-d")){
                $points = [[98.5, 2.6], [0.0, 0.0], [1.7, 100.0], [100.0, 98.3]];
            }

            $this.clipPath($points, {
                isPercentage: true,
                svgDefId: "reviewclip"+index
            })
        });

        $fn.find(".wrp_comp_foot").find(".part_ui_btn").clipPath([[0.1, 6.2], [99.9, 0.3], [96.6, 99.7], [2.3, 99.7]], {
            isPercentage: true,
            svgDefId: "reviewbtnclip"
        })
    }
}